export function linkToSurveys() {
  return "/surveys";
}

export function linkToSurveyPage(surveyId: string = ":surveyId") {
  return `${linkToSurveys()}/${surveyId}`;
}
